export const getPostType = (type?: string) => {
    switch (type) {
        case 'post':
        case 'blogger_post':
            return 'Пост';
        case 'collection':
            return 'Коллекция';
        default:
            return '';
    }
};
